export default __webpack_public_path__ + "static/media/Success.bd415b80.svg";